import {gql} from "@apollo/client";

export const SDNO_DAAP_METADATA_QUERY = gql`
    query SdnoDaapMetadata {
        sdnoDaapGeographies { name }
        sdnoDaapSubcategories { name }
    }
`

export const SDNO_DAAP_EXISTING_SUBSCRIPTIONS_QUERY = gql`
    query SdnoDaapSubscriptions (
        $emails: [String!]!
    ) {
        sdnoDaapSubscriptions(
         emails: $emails
        ) {
            geographies {
              email
              geography
            }
            subcategories {
              email
              subcategory
            }
        }
    }
`;

export const SDNO_DAAP_EXISTING_DISTRIBUTOR_PLATFORM_SUBSCRIPTIONS_QUERY = gql`
    query Query($emails: [String!]!) {
        sdnoDaapDistributorPlatformSubscription(emails: $emails) {
            distributorPlatforms {
                company
                dataSource
                email
                reportType
            }
        }
    }
`

export const SDNO_DAAP_COMPANIES_QUERY = gql`
    query SdnoDaapCompanies(
        $dataSources: [String!]!
    ) {
        sdnoDaapCompanies(
            dataSources: $dataSources
        ) {
            company
            dataSource
        }
    }
`;
